import React from 'react';
import PropTypes from 'prop-types';
import ModularSofasPage from './ModularSofasPage';

const ModularSofasPageWrapper = ({ isAdmin = false }) => {
  if (isAdmin) {
    return (
      <div className="ModularSofasStatic__container">
        <div className="flex min-h-[30vh] items-center justify-center">
          <p className="text-lg font-medium">Modular sofas placeholder</p>
        </div>
      </div>
    );
  }
  return <ModularSofasPage />;
};

ModularSofasPageWrapper.propTypes = {
  isAdmin: PropTypes.bool,
};
export default ModularSofasPageWrapper;
